// in src/i18nProvider.js
import polyglotI18nProvider from 'ra-i18n-polyglot'
import es from './ra-language-spanish'
import en from './ra-language-english'; 
import pt_br from './ra-language-pt-br' 

const messages = {
  'es-AR': es,
  'en-US': en,
  'pt-BR': pt_br,
}

const getI18nProvider = (locale) => {
  let language = locale || localStorage.getItem('language') || 'es-AR'
  // Escuchar cambios de idioma globalmente
  window.addEventListener('languageChanged', () => {
    language = localStorage.getItem('language')
  })
  return polyglotI18nProvider(() => messages[language], language)
}

export default getI18nProvider